import { Heading } from '@planningcenter/tapestry-react';
import React from 'react';
import colors from '../colors.js';

function DrawerHeading({ children, ...props }) {
    return (React.createElement(Heading, { ...props, color: colors.lightNeutral12, letterSpacing: ".002em", level: 2, lineHeight: "35px", weight: 700 }, children));
}

export { DrawerHeading };
//# sourceMappingURL=drawer_heading.js.map
